import React from 'react';

import DatasetSummary from './DatasetSummary';
import PreprocessingProgress from './PreprocessingProgress';
import CorrelationBlock from './CorrelationBlock';
import DataAnalysis from './DataAnalysis';
import TargetSuggestions from './TargetSuggestions';
import ModelTrainingProgress from './ModelTrainingProgress';
import ModelPerformance from './ModelPerformance';
import ShapSummary from './ShapSummary';
import InsightCallout from './InsightCallout';
import PredictionsTable from './PredictionsTable';
import ForecastBlock from './ForecastBlock';
import TextBubble from './TextBubble';
import ErrorBlock from './ErrorBlock';
import DeepAnalysisResult from './DeepAnalysisResult';
import TimeSeriesForecastBlock from './TimeSeriesForecastBlock';
import MultiSeriesForecastBlock from './MultiSeriesForecastBlock';
import ModelComparisonBlock from './ModelComparisonBlock';
import AnalysisOptionsBlock from './AnalysisOptionsBlock';
import QnAResultBlock from './QnAResultBlock';
import ClassifyPlanBlock from './ClassifyPlanBlock';
import CausalEffectBlock from './CausalEffectBlock';
import CausalComparisonBlock from './CausalComparisonBlock';
import CateSegmentsBlock from './CateSegmentsBlock';
import EffectCurvesBlock from './EffectCurvesBlock';

const BLOCK_MAP = {
  dataset_summary: DatasetSummary,
  preprocessing_progress: PreprocessingProgress,
  correlation_block: CorrelationBlock,
  data_analysis: DataAnalysis,
  target_suggestions: TargetSuggestions,
  model_training_progress: ModelTrainingProgress,
  model_performance: ModelPerformance,
  shap_summary: ShapSummary,
  insight_callout: InsightCallout,
  predictions_table: PredictionsTable,
  forecast: ForecastBlock,
  deep_analysis_result: DeepAnalysisResult,
  text: TextBubble,
  error: ErrorBlock,
  time_series_forecast: TimeSeriesForecastBlock,
  multi_series_forecast: MultiSeriesForecastBlock,
  model_comparison: ModelComparisonBlock,
  analysis_options: AnalysisOptionsBlock,
  qna_result: QnAResultBlock,
  classify_plan: ClassifyPlanBlock,
  causal_effect: CausalEffectBlock,
  causal_comparison: CausalComparisonBlock,
  cate_segments: CateSegmentsBlock,
  effect_curves: EffectCurvesBlock,
};

const BlockRenderer = ({ blockType, blockData, status, ...rest }) => {
  const Cmp = BLOCK_MAP[blockType];
  if (!Cmp) {
    // Unknown block — render a quiet fallback rather than crash.
    return null;
  }
  return <Cmp blockData={blockData} status={status} {...rest} />;
};

export default BlockRenderer;
